@if(loader){
<app-loader></app-loader>
}
<!-- 
<p-card> -->
<form [formGroup]="createProductForm">

    <div class="field col-12 flex justify-content-between align-items-center">

        <div class="field text-left">
            <div class="flex justify-content-between">
                <div>

                    <p-button label="Save" icon="pi pi-save" size="small" (click)="createProduct()"></p-button>

                </div>
            </div>
        </div>

        <div>
            <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>

    </div>

    <div class="grid mb">


        <div class="col">

            <div class="field text-left">
                    <label for="IsServiceType" class="label-required display">Type</label>
                     <div style="display: flex; gap: 1rem; align-items: center;">
                      <label>
                        <input type="radio" formControlName="IsServiceType"[value]="false"(change)="onTypeChange()" />Goods</label>

                    <label>
                        <input type="radio" formControlName="IsServiceType" [value]="true" (change)="onTypeChange()" /> Service
                    </label>
                    </div>

                    <!-- <div *ngIf="createProductForm.get('IsServiceType')?.invalid && createProductForm.get('IsServiceType')?.touched"
                        style="color: red;">
                        Please select a type (Goods or Service).
                    </div> -->
                    <small *ngIf="submitted && formControls.IsServiceType.errors" id="name-error" class="text-red-500">
                        Please select a type (Goods or Service).</small>
                </div>
            <br>
            <div class="field text-left custom-width">
                <label for="producttypedropdown" class="label-required display">Product Type</label>
                <p-autoComplete formControlName="producttypedropdown" appendTo="body" [dropdown]="true"
                    (onSelect)="setProductType($event)" (completeMethod)="filterProductType($event)"
                    [suggestions]="filterproducttype" field="productTypeName" styleClass="w-full"
                    placeholder="Select Product Type" (keydown)="$event.preventDefault()"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ProductType.errors}">
                    <ng-template let-item pTemplate="item">
                        <span>{{item.productTypeCode}} - {{item.productTypeName}}</span>
                    </ng-template>
                </p-autoComplete>
                <small *ngIf="submitted && formControls.ProductType.errors" id="name-error"
                    class="text-red-500">Required field.</small>
            </div>

            <div class="field text-left" style="display: flex; flex-direction: column; align-items: flex-start;">
                <label for="website" class="label-required display">Product Code</label>
                <div style="display: flex; align-items: center;">
                    <input pInputText placeholder="e.g P307" type="text" (blur)="checkProductCode()" class="w-full"
                        formControlName="ProductCode" [readonly]="iseditProduct || !formControls.manualEntry.value"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ProductCode.errors}" />
                    <div style="margin-left: 10px;">
                        <p-checkbox formControlName="manualEntry" (onChange)="manualEntry()" [binary]="true"
                            label="Manual Entry" value="true"></p-checkbox>
                    </div>

                </div>
                <small *ngIf="submitted && formControls.ProductCode.errors" id="name-error"
                    class="text-red-500">Required field.</small>
            </div>

            <div class="field text-left">
                <label for="website" class="label-required display">Product Name</label>
                <input pInputText placeholder="e.g Iphone 15 Pro" formControlName="ProductName"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ProductName.errors }" class="w-full" />
                <small *ngIf="submitted && formControls.ProductName.errors" id="name-error"
                    class="text-red-500">Required
                    field.</small>
            </div>



            <!-- <div class="field text-left">
                  <label for="website">Product Specification / Grade</label>
                  <input pInputText formControlName="ProductSpecification"
                      class="w-full p-inputtext-sm"/>
                </div> -->

        </div>

        <div class="col">

            <!-- <div class="field mt-3">
                    <fieldset class="field-setting">
                        <b>
                            <legend>Price Setting</legend>
                        </b>
                        <p-radioButton value="Qty" inputId="CostCalculation1" formControlName="CostCalculation"
                            class="radio-button"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.CostCalculation.errors }"></p-radioButton>
                        <label for="CostCalculation1">By Quantity</label>

                        <p-radioButton value="Wgt" inputId="CostCalculation2" formControlName="CostCalculation"
                            class="radio-button ml-3"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.CostCalculation.errors }"></p-radioButton>
                        <label for="CostCalculation2">By Weight</label>
                    </fieldset>
                    <small *ngIf="submitted && formControls.CostCalculation.errors" id="name-error"
                        class="text-red-500">Required
                        field.</small>

                </div> -->
            <div class="field text-left">
                <label for="website">Product Specification / Grade</label>
                <input pInputText formControlName="ProductSpecification" class="w-full" />
            </div>
            <div class="field text-left custom-width">
                <label for="UOM" class="label-required display">UOM</label>
                <p-autoComplete formControlName="UOM" appendTo="body" [dropdown]="true" (onSelect)="setUOM($event)"
                    [suggestions]="filteruom" (completeMethod)="filterUOM($event)" field="unitsofMeasure"
                    placeholder="Search UOM" styleClass="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.UnitsOfMeasure.value}">
                    <ng-template let-item pTemplate="item">
                        <span>{{item.unitsofMeasureCode}} - {{item.unitsofMeasure}}</span>
                    </ng-template>
                </p-autoComplete>
                <small *ngIf="submitted && formControls.UnitsOfMeasure.errors" id="name-error"
                    class="text-red-500">Required field.</small>
            </div>

            <div class="field text-left custom-width">
                <label for="tags" class="label-required display">Purchase Cost</label>
                <input formControlName="StandardCost" type="number" pInputText placeholder="" class="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.StandardCost.errors}" />
                <small *ngIf="submitted && formControls.StandardCost.errors" id="name-error"
                    class="text-red-500">Required field.</small>
            </div>

            <div class="field text-left custom-width">
                <label for="tags" class="label-required display">Sales Price</label>
                <input formControlName="SalesPrice" type="number" pInputText placeholder=""
                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.SalesPrice.errors}" class="w-full" />
                <small *ngIf="submitted && formControls.SalesPrice.errors" id="name-error" class="text-red-500">Required
                    field.</small>
            </div>

        </div>

        <div class="col">

            <div class="field text-left custom-width">
                <label for="website" class="label-required display"> Product Group</label>
                <p-autoComplete formControlName="ProductGroupName" [dropdown]="true" [suggestions]="filterProductGroups"
                    [forceSelection]="true" (completeMethod)="filterProductGroup($event)"
                    (onSelect)="setProductGroups($event)" field="productGroupName" placeholder="Search Product Group"
                    styleClass="w-full" [ngClass]="{
                                                   'ng-invalid ng-dirty': submitted && !createProductForm.controls.ProductGroupName.value
                                                   }" (keydown.enter)="focusNextInput($event)">
                    <ng-template let-item pTemplate="item">
                        <span>{{ item.productGroupName }}</span>
                    </ng-template>
                </p-autoComplete>

                <!-- <small *ngIf="submitted && formControls.UnitsOfMeasure.errors" id="name-error" class="text-red-500">Required field.</small> -->
            </div>

            <div class="field text-left">
                <label for="tags">Product Category</label>
                <p-autoComplete formControlName="CategoryValue" [dropdown]="true" (onSelect)="setCategory($event)"
                    (completeMethod)="filtersCatagory($event)" [suggestions]="filterCategorys" field="categoryName"
                    placeholder="Select Category" styleClass="w-full">
                    <ng-template let-item pTemplate="item">
                        <span>{{item.categoryCode}} - {{item.categoryName}}</span>
                    </ng-template>
                </p-autoComplete>
                <!-- <small *ngIf="submitted && formControls.CategoryValue.errors" id="name-error"
                    class="text-red-500">Required
                    field.</small> -->
            </div>



            <div class="field text-left custom-width">
                <label for="website"> Product SubCategory</label>

                <p-autoComplete formControlName="SubCategoryName" appendTo="body" [dropdown]="true"
                    (onSelect)="setProductSubCategory($event)" [suggestions]="filterCategorys"
                    (completeMethod)="filterSubCategory($event)" field="subCategoryName"
                    placeholder="Search SubCategory" styleClass="w-full" (keydown.enter)="focusNextInput($event)">
                    <ng-template let-item pTemplate="item">
                        <span>{{ item.subCategoryName }}</span>
                    </ng-template>
                </p-autoComplete>


            </div>

            <div class="field-group" style="display: flex; justify-content: space-between; gap: 10px; margin-top: 8px;">
                <div class="field text-left mt-1" style="margin-top: 0;">
                    <label for="hsnCode" class="label-required display">HSN/SAC Code</label>
                    <div style="display: flex; align-items: center;">
                        <input pInputText readonly (click)="getGSTList()" class="w-full p-inputtext-sm"
                            formControlName="HSNCode"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.HSNCode.value}"
                            style="height: 28px;" />
                        <div style="margin-left: 8px;">
                            <p-button icon="pi pi-search" (click)="getGSTList()" [raised]="true" [size]="'small'"
                                severity="info"></p-button>
                        </div>
                    </div>
                </div>
                <div class="field text-left mt-1" style="margin-top: 0;">
                    <label for="gstRate" class="label-required display">GST Rate (%)</label>
                    <div style="display: flex; align-items: center;">
                        <input pInputText type="text" class="w-full p-inputtext-sm" formControlName="gstRate" readonly
                            placeholder="GST Rate"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && !this.createProductForm.controls.gstRate.value}"
                            style="height: 28px;" />
                    </div>
                </div>
            </div>
        </div>

    </div>


</form>
<!-- </p-card> -->    <p-toast></p-toast>
